import { CountryCodes } from '@e3dc-react/shell/Hooks/useCountryOptions'

export const PRODUCT_CART_DEBOUNCE_TIMER = 1000
export const ORDER_HISTORY_DATE_FORMAT = 'yyyy-MM-dd'
export const SYSTEM_CONFIGURE_PROGRESS_PAGE_PARAM = 'page'
export const SHOP_ADMIN_PERMISSION = 'E3DC_'
export const TOTAL_PRODUCTS_PER_PAGE = 24
export const SHOP_NOT_ALLOWED_LOCATIONS = ['CHE']
export const VAD_CUSTOMER_GROUP_ID = '4118834b38154ac986f25bbfc4c6fb2f'
export const SHOP_ALLOWED_LOCATIONS = [CountryCodes.GERMANY, CountryCodes.AUSTRIA]
export const SHOP_AVIS_SHIPPING_METHOD_ID = '20197424cd2a4872b84cfca075fdae45'
/** Shipping Method Id for Quantom Only */
export const SHOP_QNTM_SELF_PICK_SHIPPING_METHOD_ID = 'ca79f425dbc94dbb93a2c3ac51ef92ce'
export const SHOP_QNTM_DELIVERY_PICK_SHIPPING_METHOD_ID = '20120db5ff7c44438132aeb46063e32f'
/** Shop Channel UUID's */
export const SHOP_E3DC_ID = '151cd0aa73ac490b937692d0881f4449'
export const SHOP_INTERNAL_CH_ID = 'e4a31eef38c943e997d2a12a4e45a53e'
export const SHOP_INTERNAL_NL_ID = 'be2151b595d24dbfb0ffe901b0bda551'
export const SHOP_INTERNAL_FLOW_ID = '47b43e3a0bd74c96a1398bfd26041e87'
